import QuotesDeliveryColumn from "@/Shared/Quotes/CustomComponents/QuotesDeliveryColumn";
import QuotesPickupColumn from "@/Shared/Quotes/CustomComponents/QuotesPickupColumn";
import QuotesProgress from "@/Shared/Quotes/CustomComponents/QuotesProgress";
import type { LineItem } from "@freightsimple/generated-dashboard-openapi-client/models/LineItem";
import type { PreQuoteLocation } from "@freightsimple/generated-dashboard-openapi-client/models/PreQuoteLocation";
import { ShipmentState } from "@freightsimple/generated-dashboard-openapi-client/models/ShipmentState";
import type { EquipmentType } from "@freightsimple/generated-dashboard-openapi-client/models/EquipmentType";
import { isDomesticCanada } from "@/Helpers/isDomesticCanada";
import moment from "moment";

interface TwoColumnShipmentViewProps {
  pickupDeadline: string | undefined;
  lineItems: LineItem[];
  pickupDate: string;
  pickupLocation: PreQuoteLocation;
  deliveryLocation: PreQuoteLocation;
  deliveryDeadline: string | undefined;
  equipmentType: EquipmentType | undefined;
  exclusiveUse: boolean;
  tarpRequired: boolean;
  linearFeet: number | undefined;
  pickupReferenceNumber?: string | undefined;
  deliveryReferenceNumber?: string | undefined;
  deliveryAmazonReferenceId?: string | undefined;
  deliveryAmazonShipmentId?: string | undefined;
}

export function BookShipmentTwoColumnView(props: TwoColumnShipmentViewProps) {
  const {
    lineItems,
    pickupDate,
    pickupLocation,
    deliveryLocation,
    deliveryDeadline,
    equipmentType,
    exclusiveUse,
    tarpRequired,
    linearFeet,
    pickupDeadline,
  } = props;

  return (
    <div className="flex flex-col items-center" style={{ width: "600px" }}>
      <QuotesProgress shipmentState={ShipmentState.Quoted} twoColumns />
      <div className="h-[16px]" />
      <div className="flex w-full flex-row items-start">
        <QuotesPickupColumn
          pickupDeadline={pickupDeadline}
          lineItems={lineItems}
          pickupDate={moment(pickupDate)}
          pickupLocation={pickupLocation}
          pickupContact={undefined}
          quote={undefined}
          shipmentState={ShipmentState.Quoted}
          equipmentType={equipmentType}
          exclusiveUseNeeded={exclusiveUse}
          tarpRequired={tarpRequired}
          linearFeet={linearFeet}
          isDomesticCanada={isDomesticCanada(pickupLocation, deliveryLocation)}
          showNotesSection={true}
          twoColumn
          hidePickupHours
          pickupReferenceNumber={props.pickupReferenceNumber}
        />
        <QuotesDeliveryColumn
          quote={undefined}
          deliveryHours={undefined}
          appointmentDate={undefined}
          deliveryLocation={deliveryLocation}
          deliveryContact={undefined}
          shipmentState={ShipmentState.Quoted}
          actualDeliveryDate={undefined}
          actualDeliveryTime={undefined}
          deliveryDeadline={deliveryDeadline}
          expectedDeliveryDate={undefined}
          latestExpectedDeliveryDate={undefined}
          showNotesSection={true}
          twoColumn
          hideExpectedDelivery
          deliveryReferenceNumber={props.deliveryReferenceNumber}
          deliveryAmazonReferenceId={props.deliveryAmazonReferenceId}
          deliveryAmazonShipmentId={props.deliveryAmazonShipmentId}
        />
      </div>
    </div>
  );
}
